import { render, staticRenderFns } from "./DataFormatsTable.vue?vue&type=template&id=2d1df19a&"
import script from "./DataFormatsTable.vue?vue&type=script&lang=js&"
export * from "./DataFormatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports